import { render } from "./RetrabalhosPorProgramador.vue?vue&type=template&id=cc6b3116"
import script from "./RetrabalhosPorProgramador.vue?vue&type=script&lang=js"
export * from "./RetrabalhosPorProgramador.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__